import { render } from "./ConfirmPCZ.vue?vue&type=template&id=64ad72ad"
import script from "./ConfirmPCZ.vue?vue&type=script&lang=js"
export * from "./ConfirmPCZ.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__